<!-- 提现信息 -->
<template>
  <div>
    <div class="banner">
      <el-form style="margin-top:30px;margin-left:30px" label-width="170px">
        <!-- <el-form-item label="店铺描述：" :rules="[ { required: true} ]" prop>
          <el-input v-model="Notice" auto-complete="off" style="width:560px" maxlength="20" placeholder="请输入店铺描述（20字以内）"/>
        </el-form-item>
        <el-form-item label="联系电话：" :rules="[ { required: true} ]" prop>
          <el-input v-model="TelPhone" auto-complete="off" style="width:560px" maxlength="11" placeholder="请输入联系电话"/>
        </el-form-item>
        <el-form-item label="店铺负责人：" :rules="[ { required: true} ]" prop>
          <el-input v-model="Contacts" auto-complete="off" style="width:560px" maxlength="15" placeholder="请输入店铺负责人"/>
        </el-form-item>
        <el-form-item label="负责人联系电话：" :rules="[ { required: true} ]" prop>
          <el-input v-model="Phone" auto-complete="off" style="width:560px" maxlength="11" placeholder="请输入负责人联系电话："/>
        </el-form-item> -->

        <el-form-item label="提现负责人姓名：" :rules="[ { required: true} ]" prop>
          <el-input v-model="withdrawerName" auto-complete="off" style="width:560px" maxlength="15" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="提现负责人手机：" :rules="[ { required: true} ]" prop>
          <el-input v-model="withdrawerPhone" auto-complete="off" style="width:560px" maxlength="11" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="收款账户信息：" :rules="[ { required: true} ]" prop>
          <el-radio-group v-model="collection" @change="radioType()">
            <el-radio :label="1">公司个体户</el-radio>
            <el-radio :label="2">个人账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开户银行支行所在地：" :rules="[ { required: true} ]" prop>
          <el-select v-model="provinceId" style="width:185px;" placeholder="请选择省" @change="getCity()">
            <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in tbdprovince" :key="index"/>
          </el-select>
          <el-select style="width:185px;" v-model="cityId" placeholder="请选择市 " @change="getzone()">
            <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in tbdcity" :key="index"/>
          </el-select>
          <el-select style="width:185px;" v-model="zoneId" placeholder="请选择区">
            <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in tbdzone" :key="index"/>
          </el-select>
        </el-form-item>
        <el-form-item label="开户行银行名称：" :rules="[ { required: true} ]" prop>
          <el-input v-model="BankName" auto-complete="off" style="width:560px" maxlength="30" placeholder="请输入开户行银行名称"/>
        </el-form-item>
        <el-form-item label="账号名称：" :rules="[ { required: true} ]" prop>
          <el-input v-model="AccountName" auto-complete="off" style="width:560px" maxlength="30" placeholder="请输入账号名称"/>
        </el-form-item>
        <el-form-item :label="bankAccount" :rules="[ { required: true} ]" prop>
          <el-input v-model="BankNo" auto-complete="off" style="width:560px" maxlength="30" placeholder="请输入公司银行账号"/>
        </el-form-item>
        <el-form-item :label="distinguish"  :rules="[ { required: true} ]" prop>
          <el-input v-model="TaxpayerAccount" auto-complete="off" style="width:560px" maxlength="30" placeholder="请输入纳税人识别号"/>
        </el-form-item>
      </el-form>
      <div class="gudingdibu">
        <el-button type="danger" @click="emit()">保 存</el-button>
        <el-button @click="goback()">返 回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getkind } from "../../api/api";
import { getExtendInfo, putEditExtendInfo } from "../../api/shopWindow";
export default {
  name: "tixian",
  data() {
    return {
      loading2: true,
      shopinfo: "",
      // Notice: "",
      // TelPhone: "",
      // Contacts: "",
      // Phone: "",
      withdrawerName: '', // 提现负责人姓名
      withdrawerPhone: '', // 提现负责人手机
      collection: 1, // 收款账户信息
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      BankName: "",
      AccountName: "",
      BankNo: "",
      TaxpayerAccount: "",
      tbdprovince: [],
      tbdcity: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      tbdzone: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      bankAccount: '公司银行账号：',
      distinguish: '纳税人识别号：'
    };
  },
  methods: {
    // 切换收款账户信息
    radioType(val) {
      // this.provinceId = 0;
      // this.cityId = 0;
      // this.zoneId = 0;
      // this.BankName = "";
      // this.AccountName = "";
      // this.BankNo = "";
      // this.TaxpayerAccount = "";

      if (this.collection == 1) {
        this.bankAccount = '公司银行账号：';
        this.distinguish = '纳税人识别号：';
      }
      if (this.collection == 2) {
        this.bankAccount = '银行账号：';
        this.distinguish = '个人身份证号码：';
      }
    },
    goback(){
      this.$router.go(-1)
    },
    // 回显数据
    getinfobyId() {
      var obj = {
        bbid: localStorage.businessBbId
        // queryType: 3
      };
      getExtendInfo(obj).then(data => {
        if (data.resultCode == 1) {
          this.shopinfo = data.resultObj;
          // if(this.shopinfo.Notice+"" == "null"||this.shopinfo.Notice == ""){
          //   this.Notice == ""
          // }else{
          //   this.Notice = this.shopinfo.Notice;
          // }
          // this.TelPhone = this.shopinfo.TelPhone;
          // this.Contacts = this.shopinfo.Contacts;
          // this.Phone = this.shopinfo.Phone;
          
          this.withdrawerName = this.shopinfo.withdrawalName; // 提现负责人姓名
          this.withdrawerPhone = this.shopinfo.withdrawalPhone; // 提现负责人手机
          this.collection = this.shopinfo.collectionAccountType; // 收款账户信息

          this.provinceId = this.shopinfo.bankProvinceId;
          this.cityId = this.shopinfo.bankCityId;
          this.zoneId = this.shopinfo.bankZoneId;
          this.BankName = this.shopinfo.bankName;
          this.AccountName = this.shopinfo.accountName;
          this.BankNo = this.shopinfo.bankNo;
          this.TaxpayerAccount = this.shopinfo.taxpayerAccount;
          // BrandIds: this.Brandarr.join(","),
          // BrandTypeIds: this.Brandtypearr.join(","),
          // OpenBWeek: this.OpenBWeek,
          // OpenEWeek: this.OpenEWeek,
          // OpenBDay: this.OpenBDay,
          // OpenEDay: this.OpenEDay,
          this.getprovince();
          this.getcity();
          this.getZone();
        }
      });
    },
    //验证
    isvieid() {
      // if (this.Notice == ""||this.Notice+""=="null") {
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入店铺描述"
      //   })
      //   return false;
      // }
      // if (this.TelPhone == "") {
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入联系电话"
      //   })
      //   return false;
      // }
      // if(/^1[3456789]\d{9}$/.test(this.TelPhone) == false){
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入正确的联系电话"
      //   })
      //   return false;
      // }
      // if (this.Contacts == "") {
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入店铺负责人"
      //   })
      //   return false;
      // }
      // if (this.Phone == "") {
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入联系人电话"
      //   })
      //   return false;
      // }
      // if(/^1[3456789]\d{9}$/.test(this.Phone) == false){
      //   this.$swal({
      //     type:"warning",
      //     text:"请输入正确的联系人电话"
      //   })
      //   return false;
      // }
      if (this.withdrawerName == '') {
        this.$swal({
          type:"warning",
          text:"请输入提现负责人姓名"
        })
        return false;
      }
      if (this.withdrawerPhone == '') {
        this.$swal({
          type:"warning",
          text:"请输入提现负责人手机"
        })
        return false;
      }

      if (this.provinceId == 0) {
        this.$swal({
          type:"warning",
          text:"请选择店铺所在省"
        })
        return false;
      }
      if (this.cityId == "") {
        this.$swal({
          type:"warning",
          text:"请选择店铺所在市"
        })
        return false;
      }
      if (this.zoneId == "") {
        this.$swal({
          type:"warning",
          text:"请选择店铺所在区域"
        })
        return false;
      }
      if (this.BankName == "") {
        this.$swal({
          type:"warning",
          text:"请输入开户行银行名称"
        })
        return false;
      }
      if (this.AccountName == "") {
        this.$swal({
          type:"warning",
          text:"请输入账号名称"
        })
        return false;
      }
      if (this.BankNo == "") {
        this.$swal({
          type:"warning",
          text:"请输入公司银行账号"
        })
        return false;
      }
      if (this.TaxpayerAccount == "") {
        this.$swal({
          type:"warning",
          text:"请输入纳税人识别号"
        })
        return false;
      } else {
        return true;
      }
    },
    // 保存修改
    emit() {
      if (this.isvieid()) {
        this.loading2 = true;
        this.$emit("loadingfun", this.loading2);
        var obj = {
          // UserId: localStorage.Id,
          bbid: localStorage.businessBbId,
          withdrawalName: this.withdrawerName,
          withdrawalPhone: this.withdrawerPhone,
          collectionAccountType: this.collection,
          bankProvinceId: this.provinceId,
          bankCityId: this.cityId,
          bankZoneId: this.zoneId,
          bankName: this.BankName,
          accountName: this.AccountName,
          bankNo: this.BankNo,
          taxpayerAccount: this.TaxpayerAccount,
          // BbModel: {
          //   Notice: this.Notice,
          //   TelPhone: this.TelPhone,
          //   Contacts: this.Contacts,
          //   Phone: this.Phone
          // },
          // operType: 3
        };
        putEditExtendInfo(obj).then(data => {
          if (data.resultCode == 1) {
            this.loading2 = false;
            this.$emit("loadingfun", this.loading2);
            localStorage.businessBbId = data.resultMsg;
              this.$swal({
              type:"success",
              text:"保存成功"
            })
          }
        });
      }
    },
    //市
    getCity() {
      this.getcity();
      this.cityId = 0;
      this.zoneId = 0;
      this.tbdzone = [
        {
          Id: 0,
          Name: "全部"
        }
      ];
    },
    getzone() {
      this.getZone();
      this.zoneId = 0;
    },
    //查找省
    getprovince() {
      let that = this;
      var loginParams = {
        tableName: "tbdprovince",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.tbdprovince = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //查找市
    getcity() {
      let that = this;
      var loginParams = {
        tableName: "tbdcity",
        keyWord: "",
        parentId: this.provinceId
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.tbdcity = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    //查找区
    getZone() {
      let that = this;
      var loginParams = {
        tableName: "tbdzone",
        keyWord: "",
        parentId: this.cityId
      };
      getkind(loginParams)
        .then(data => {
          data = data.ResultObj;
          var obj = {
            Id: 0,
            Name: "全部"
          };
          data.unshift(obj);
          that.tbdzone = data;
        })
        .catch(err => {
          this.logining = false;
        });
    },
    init() {
      if (this.$route.query.type == 1) {
        this. getinfobyId()
        // this.getcity();
        // this.getZone();
        // this.shopinfo = this.shopinfoextend;
        // this.Notice = this.shopinfo.Notice;
        // this.TelPhone = this.shopinfo.TelPhone;
        // this.Contacts = this.shopinfo.Contacts;
        // this.Phone = this.shopinfo.Phone;
        // this.provinceId = this.shopinfo.BankProvinceId;
        // this.cityId = this.shopinfo.BankCityId;
        // this.zoneId = this.shopinfo.BankZoneId;
        // this.BankName = this.shopinfo.BankName;
        // this.AccountName = this.shopinfo.AccountName;
        // this.BankNo = this.shopinfo.BankNo;
        // this.TaxpayerAccount = this.shopinfo.TaxpayerAccount;
      }
    }
  },
  mounted() {
    this.getprovince();
    this.getcity();
    this.getZone();
    // if (this.$route.query.type == 1) {
    //   this.shopinfo = this.shopinfoextend;
    //   this.Notice = this.shopinfo.Notice;
    //   this.TelPhone = this.shopinfo.TelPhone;
    //   this.Contacts = this.shopinfo.Contacts;
    //   this.Phone = this.shopinfo.Phone;
    //   this.provinceId = this.shopinfo.BankProvinceId;
    //   this.cityId = this.shopinfo.BankCityId;
    //   this.zoneId = this.shopinfo.BankZoneId;
    //   this.BankName = this.shopinfo.BankName;
    //   this.AccountName = this.shopinfo.AccountName;
    //   this.BankNo = this.shopinfo.BankNo;
    //   this.TaxpayerAccount = this.shopinfo.TaxpayerAccount;
    // }
    // this.init();
    if(this.$route.query.type ==1){
      this.init()
    }
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// tixian.vue?00f0f686